import React, { Fragment, useContext, useEffect, useState, memo } from "react";

// Provider
import { AppContext } from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";
import { Container } from "../Layout";
import { Base64 } from 'js-base64';

export default () => {
    const {userinfo, cfg, phonecfg} = useContext(AppContext);
    
    let src = "https://hs.mdpeople.co.kr/login.aspx?name=" + encodeURIComponent(Base64.encode(userinfo.userName)) + "&phone=" + userinfo.userPhone + "&sex=" + userinfo.sex + "&birth=" + userinfo.birth;

    console.log(src);
    return(
        <Fragment>
            <Container Title="문진표작성" dark="dark" goToUrl="/">
                <div className="contents">
                    <div className="sub-contents" style={{padding:"0px"}}>
                        <iframe src={src} style={{width:"100%", height:"100px", display:"block", border:"0px"}} onLoad={(e)=>resize(e)}/>
                    </div>
                </div>
            </Container>
        </Fragment>
    );
}

const resize = (e) => {
    let ifmHeight = (document.body.clientHeight) + "px";
	$(e.target).css("height", ifmHeight);
}